import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  requestingHardcopy: false,
  raisingDispute: false,
  contactSupport: false,
  feedback: false,
  error: null,
  details: null,
  fetchingDropdown: false,
  downloadInProgress: false,
  dropdowns: {},
  updatePoInProgress: false,
  addGRN: false,
  updateGRNDetails: false,
  checkForGRN: null,
  fetchCompanyFeatures: false,
};

const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {
    fetchOrderDetails(state, action) {
      state.loading = true;
    },
    fetchOrderDetailsSuccess(state, action) {
      state.details = action.payload.data.document;
      state.loading = false;
    },
    fetchOrderDetailsFailure(state, action) {
      state.loading = false;
    },
    fetchOrderDetailsReset(state, action) {
      state.details = null;
    },
    requestReportHardCopy(state, action) {
      state.requestingHardcopy = true;
    },
    requestReportHardCopySuccess(state, action) {
      state.requestingHardcopy = false;
    },
    requestReportHardCopyFailure(state, action) {
      state.requestingHardcopy = false;
      state.error = action.payload.message;
    },
    raiseDispute(state, action) {
      state.raisingDispute = true;
    },
    raiseDisputeSuccess(state, action) {
      state.raisingDispute = false;
    },
    raiseDisputeFailure(state, action) {
      state.raisingDispute = false;
      state.error = action.payload.message;
    },
    contactSupport(state, action) {
      state.contactSupport = true;
    },
    contactSupportSuccess(state, action) {
      state.contactSupport = false;
    },
    contactSupportFailure(state, action) {
      state.contactSupport = false;
      state.error = action.payload.message;
    },
    feedback(state, action) {
      state.feedback = true;
    },
    feedbackSuccess(state, action) {
      state.feedback = false;
    },
    feedbackFailure(state, action) {
      state.feedback = false;
      state.error = action.payload.message;
    },
    downloadFile(state, action) {
      state.downloadInProgress = true;
    },
    downloadFileSuccess(state, action) {
      state.downloadInProgress = false;
    },
    downloadFileFailure(state, action) {
      state.downloadInProgress = false;
    },
    updatePurchaseOrder(state, action) {
      state.updatePoInProgress = true;
    },
    updatePurchaseOrderSuccess(state, action) {
      state.details = action.payload.data.document;
      state.updatePoInProgress = false;
    },
    updatePurchaseOrderFailure(state, action) {
      state.updatePoInProgress = false;
      state.error = action.payload.error;
    },
    addGRN(state, action) {
      state.addGRN = true;
    },
    addGRNSuccess(state, action) {
      state.addGRN = false;
    },
    addGRNFailure(state, action) {
      state.addGRN = false;
      state.error = action.payload.error;
    },
    updateGRNDetails(state, action) {
      state.updateGRNDetails = true;
    },
    updateGRNDetailsSuccess(state, action) {
      state.updateGRNDetails = false;
    },
    updateGRNDetailsFailure(state, action) {
      state.updateGRNDetails = false;
      state.error = action.payload.error;
    },
    fetchCompanyFeatures(state, action) {
      state.fetchCompanyFeatures = true;
    },
    fetchCompanyFeaturesSuccess(state, action) {
      state.fetchCompanyFeatures = false;
      state.checkForGRN = action.payload.data.document;
    },
    fetchCompanyFeaturesFailure(state, action) {
      state.fetchCompanyFeatures = false;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = orderDetailsSlice;
